import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";

function Form() {
  const formRef = useRef();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email is invalid";
    }
    if (!formData.subject.trim()) newErrors.subject = "Subject is required";
    if (!formData.message.trim()) newErrors.message = "Message is required";
    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    emailjs
      .sendForm(
        "service_navxtk9",
        "template_lraaxwg",
        formRef.current,
        "01wax9DxUYNGAr7al"
      )
      .then(
        () => {
          setSuccessMessage("Message sent successfully!");
          setFormData({ name: "", email: "", subject: "", message: "" });
          setErrors({});
        },
        (error) => {
          console.error("FAILED...", error.text);
        }
      );
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className="p-6 mt-2 md:mt-12 md:p-24 md:py-6 lg:p-16 w-full h-fit">
      <div
        className="rounded-md flex flex-col p-4 pt-8 md:p-10 border-2 border-blue-400"
        data-aos="flip-left"
      >
        <h1
          className="text-3xl lg:text-5xl font-semibold tracking-wide mb-2 text-center text-[#0218DC]"
          style={{ fontFamily: "Nunito Sans, sans-serif" }}
        >
          Contact Form
        </h1>
        <form
          ref={formRef}
          onSubmit={handleSubmit}
          className="flex flex-col gap-4 md:px-8"
          style={{ fontFamily: "Poppins, sans-serif" }}
        >
          <input
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Your Name"
            className="py-4 bg-transparent rounded-lg px-4 border border-[#12D2EC] placeholder-black w-full"
            type="text"
          />
          {errors.name && <p className="text-red-500 text-sm">{errors.name}</p>}

          <input
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Your Email"
            className="py-4 bg-transparent rounded-lg px-4 border border-[#12D2EC] placeholder-black w-full"
            type="email"
          />
          {errors.email && (
            <p className="text-red-500 text-sm">{errors.email}</p>
          )}

          <input
            name="subject"
            value={formData.subject}
            onChange={handleChange}
            placeholder="Subject"
            className="py-4 bg-transparent rounded-lg px-4 border border-[#12D2EC] placeholder-black w-full"
            type="text"
          />
          {errors.subject && (
            <p className="text-red-500 text-sm">{errors.subject}</p>
          )}

          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="Your Message"
            className="h-24 py-4 bg-transparent rounded-lg px-4 border border-[#12D2EC] placeholder-black w-full"
          />
          {errors.message && (
            <p className="text-red-500 text-sm">{errors.message}</p>
          )}

          <div className="flex justify-center mt-4">
            <button
              type="submit"
              className="text-md tracking-widest py-2 px-4 w-[68%] md:w-[50%] lg:w-[35%] bg-[#0218DC] rounded-lg hover:bg-blue-700 text-white"
            >
              Send Message
            </button>
          </div>

          {successMessage && (
            <p className="text-green-500 text-center mt-2">{successMessage}</p>
          )}
        </form>
      </div>
    </div>
  );
}

export default Form;
